import { isMemberAddressLocationResponse, } from '@urbanik/api-contracts';
export class MemberAddressLocationApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
    }
}
async function call(url, init) {
    let r;
    try {
        r = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
            },
        });
    }
    catch {
        throw new MemberAddressLocationApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
    const p = await r.json().catch(() => null), message = p && typeof p.message === 'string' ? p.message : 'No pudimos completar la solicitud.';
    if (!r.ok) {
        const kind = r.status === 400
            ? 'validation'
            : r.status === 401
                ? 'unauthorized'
                : r.status === 403
                    ? 'forbidden'
                    : r.status === 404
                        ? 'not-found'
                        : r.status === 409
                            ? 'conflict'
                            : 'unavailable';
        throw new MemberAddressLocationApiError(kind, message);
    }
    if (!isMemberAddressLocationResponse(p))
        throw new MemberAddressLocationApiError('invalid', 'El contrato de dirección y ubicación es inválido.');
    return p;
}
export const getMemberAddressLocation = (base, id, signal) => call(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}/address-location`, {
    signal: signal ?? null,
});
export const updateMemberAddressLocation = (base, id, input) => call(`${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(id)}/address-location`, {
    method: 'PUT',
    body: JSON.stringify(input),
});
